import * as React from 'react';
import { instanceToPlain, plainToInstance } from 'class-transformer';
import { useLocation, useNavigate } from 'react-router-dom';
import FormStepper from 'components/form-stepper/FormStepper';
import { TypeMode } from 'constants/TypeMode';
import StandardForm from 'components/shared/StandardForm';

// eslint-disable-next-line react/prop-types, no-unused-vars
const AddDataStandardForm = ({
    navigateTo,
    slice,
    service,
    pageTitle,
    config,
    entity,
}) => {
    const navigate = useNavigate();

    const location = useLocation();
    const lastSubmittedData = React.useRef(null);

    const handleOnClose = () => {
        const savedData = lastSubmittedData.current;
        if (savedData?.parentUnitId && navigateTo.includes('setting')) {
            // Navigate to Units tab with parentUnitId for filtering and highlight the new unit
            navigate(`${navigateTo}?tab=1`, {
                state: JSON.stringify({
                    refresh: true,
                    parentUnitId: savedData.parentUnitId,
                    highlightUnitId: savedData.createdUnitId,
                }),
            });
        } else {
            navigate(navigateTo, { state: 'refresh' });
        }
        lastSubmittedData.current = null;
    };

    const handleOnSubmit = async (data, successCallback, errorCallback) => {
        try {
            // eslint-disable-next-line react/prop-types
            const response = await service.create(data);
            // Store both the submitted data and the created unit's ID from response
            const createdUnitId = response?.data?.body?.id || response?.data?.id || response?.body?.id;
            lastSubmittedData.current = { ...data, createdUnitId };
            successCallback('Data saved');
        } catch (err) {
            errorCallback(err, 'An error occurred');
        }
    };

    const defaultVal = React.useMemo(() => {
        let stateData = {};
        if (location?.state) {
            try {
                const parsed = JSON.parse(location.state);
                stateData = parsed?.row || {};
            } catch (e) {
                // Invalid JSON, use empty object
                stateData = {};
            }
        }
        let value = plainToInstance(
            entity,
            stateData,
            { exposeDefaultValues: true },
        );
        if (value && value.hasOwnProperty('parentUnitId')) {
            value = { ...value, parentUnitId: +value.parentUnitId };
        }
        if (value) {
            delete value.id;
            delete value.uuid;
        }
        return value || {};
    }, [location?.state, entity]);

    return (
        <StandardForm
            title={pageTitle}
            mode={TypeMode.Create}
            status={'success'}
            formConfig={config}
            defaultValue={defaultVal}
            onClose={handleOnClose}
            onSubmit={handleOnSubmit}
            slice={slice}
        >
            {({ formConfig, methods, defaultValue, activeStep, mode }) => (
                <FormStepper
                    forms={formConfig}
                    methods={methods}
                    status={'success'}
                    defaultValue={defaultValue}
                    activeStep={activeStep}
                    mode={mode}
                />
            )}
        </StandardForm>
    );
};

export default AddDataStandardForm;
